// src/components/PrintEnquiryStatus.js
import React from "react";
import moment from "moment";
import { Col, Row, Button, Container, Table } from "reactstrap";
import "./PrintEnquiry.css";
import { Typography } from "@material-ui/core";

const PrintEnquiryStatus = React.forwardRef((props, ref) => {
  const { enquiryData, otherCostDescription, miscellaneousData } = props;

  const formatDollar = (amount) => {
    if (!amount) {
      return "$0.00"
    }

    const txn_amount = Number(amount)

    if (txn_amount >= 0) {
      return `$${txn_amount}`
    } else {
      return `- $${txn_amount * -1}`

    }
  }
  const getTotalCredit = (credits) => {
    const totalCredit = (credits ?? []).reduce(
      (sum, item) => sum + (Number(item.credit_amount) || 0),
      0
    );

    return totalCredit
  }

  const cardPayments = enquiryData?.Transactions?.filter(
    (t) => t.payment_method === "Card"
  );

  const otherPayments = enquiryData?.Transactions?.filter(
    (t) => t.payment_method !== "Card"
  );

  return (
    <>
      <style>{`
        @media print {
          body {
            font-size: 12px;
          }
          table th, table td {
            font-size: 12px;
          }
          table th {
            // white-space: nowrap !important;
          }
      `}
      </style>
      <div className="application_card application_card_print" style={{ padding: "30px", background: "white" }} ref={ref}>
        <div className="print_header printinvoice_headers">
          <div style={{ flex: "1", border: "1px solid black", padding: "20px" }}>
            <div style={{ fontSize: "18px" }}>
              Application Details of{" "}
              <b style={{ color: "#1a6379" }}>
                {enquiryData
                  ? (enquiryData?.first_name || "") + " " + (enquiryData?.middle_name || "") + " " + (enquiryData?.last_name || "")
                  : null}
              </b>
            </div>

            {/* <div className="form-group creatadmin">
          <div className="rowPrint">
            <div className="columnPrint">
              <label>No Of Participants With Air Fare:</label>
              <br />
              <p>
                {enquiryData
                  ? enquiryData?.number_of_participants_with_airfare
                  : null}
              </p>
            </div>
            <div className="columnPrint">
              <label>No Of Participants With Out Air Fare:</label>
              <br />
              <p>
                {enquiryData
                  ? enquiryData?.number_of_participants_with_out_airfare
                  : null}
              </p>
            </div>
          </div>
        </div> */}
            <div style={{ display: "flex", marginTop: "10px" }}>
              <p className="provider_containertitle">Personal Details</p>
              <hr style={{ flex: "1", marginLeft: "20px" }} />
            </div>
            <div className="form-group creatadmin2">
              <div className="rowPrint">
                <div className="columnPrint">
                  <label>First Name:</label>
                  <br />
                  <p>{enquiryData ? enquiryData?.first_name : null}</p>
                </div>
                <div className="columnPrint">
                  <label>Last Name:</label>
                  <br />
                  <p>{enquiryData ? enquiryData?.last_name : null}</p>
                </div>
                <div className="columnPrint">
                  <label>Gender:</label>
                  <br />
                  <p>{enquiryData ? enquiryData?.gender : null}</p>
                </div>
                <div className="columnPrint">
                  <label>Email:</label>
                  <br />
                  <p>{enquiryData ? enquiryData?.email_address : null}</p>
                </div>
              </div>
            </div>
            <div className="form-group creatadmin">
              <div className="rowPrint">
                <div className="columnPrint">
                  <label>Contact No.:</label>
                  <br />
                  <p>{enquiryData ? enquiryData?.phone_number : null}</p>
                </div>
                {enquiryData?.date_of_birth && (
                  <div className="columnPrint">
                    <label>Date Of Birth:</label>
                    <br />
                    <p>
                      {moment(enquiryData?.date_of_birth).format("MM/DD/YYYY")}
                    </p>
                  </div>
                )}
                <div className="columnPrint">
                  <label>Passport number:</label>
                  <br />
                  <p>{enquiryData ? enquiryData?.passport_number : null}</p>
                </div>
                <div className="columnPrint">
                  <label>Passport Expiration Date:</label>
                  <br />
                  <p>
                    {enquiryData?.passport_expiration_date
                      ? moment(enquiryData?.passport_expiration_date).format(
                        "MM/DD/YYYY"
                      )
                      : null}
                  </p>
                </div>
              </div>
            </div>

            <div style={{ display: "flex", marginTop: "10px" }}>
              <p className="provider_containertitle">Address</p>
              <hr style={{ flex: "1", marginLeft: "20px" }} />
            </div>
            <div className="form-group creatadmin2">
              <div className="rowPrint">
                <div className="columnPrint">
                  <label>Address:</label>
                  <br />
                  <p>{enquiryData ? enquiryData?.address : null}</p>
                </div>
                <div className="columnPrint">
                  <label>City:</label>
                  <br />
                  <p>{enquiryData ? enquiryData?.city : null}</p>
                </div>
                <div className="columnPrint">
                  <label>State:</label>
                  <br />
                  <p>{enquiryData ? enquiryData?.state : null}</p>
                </div>
                <div className="columnPrint">
                  <label>Zip Code:</label>
                  <br />
                  <p>{enquiryData ? enquiryData?.zip : null}</p>
                </div>
              </div>
            </div>
            <div className="form-group creatadmin">
              <div className="rowPrint">
                <div className="columnPrint">
                  <label>Country:</label>
                  <br />
                  <p>{enquiryData ? enquiryData?.nationality : null}</p>
                </div>
              </div>
            </div>

            <div className="form-group creatadmin">
              <div style={{ display: "flex", marginTop: "10px" }}>
                <p className="provider_containertitle">Tour Details</p>
                <hr style={{ flex: "1", marginLeft: "20px" }} />
              </div>
              <div className="rowPrint">
                <div className="columnPrint">
                  <label>Interested Tour Name:</label>
                  <br />
                  <p>{enquiryData ? enquiryData?.intrested_tour : null}</p>
                </div>
                <div className="columnPrint">
                  <label>Tour Start Date:</label>
                  <br />
                  <p>
                    {enquiryData?.trip_start_date
                      ? moment(enquiryData?.trip_start_date).format("MM/DD/YYYY")
                      : null}
                  </p>
                </div>
                <div className="columnPrint">
                  <label>Tour End Date:</label>
                  <br />
                  <p>
                    {enquiryData?.trip_end_date
                      ? moment(enquiryData?.trip_end_date).format("MM/DD/YYYY")
                      : null}
                  </p>
                </div>
                {/* <div className="columnPrint">
                <label>Package:</label>
                <br />
                <p>
                  {enquiryData.accommodation_only
                    ? "Accommodation"
                    : "Ticket"}
                </p>
              </div> */}
                {/* <div className="columnPrint">
                <label>Insurance:</label>
                <br />
                <p>{enquiryData.insurance ? "Yes" : "NO"}</p>
              </div> */}
                {/* <div className="columnPrint">
              <label>Total Price:</label>
              <br />
              <p>
                {" "}
                {enquiryData.total_price
                  ? `$ ${enquiryData.total_price}`
                  : `$${0}`}
              </p>
            </div> */}
                {/* <div className="columnPrint">
              <label>Mode Of Tour:</label>
              <br />
              <p>{enquiryData ? enquiryData?.mode_of_tour : null}</p>
            </div> */}
              </div>
              <div className="rowPrint">
                <div className="columnPrint">
                  <label>Package:</label>
                  <br />
                  <p>
                    {[
                      enquiryData.full_package && `Full Package (${formatDollar(enquiryData.full_package_price)})`,
                      enquiryData.accommodation_only && `Accommodation (${formatDollar(enquiryData.accommodation_only_price)})`,
                      enquiryData.insurance && `Insurance (${formatDollar(enquiryData.insurance_price)})`,
                      enquiryData.single_room_cost_only && `Single Room (${formatDollar(enquiryData.single_room_cost)})`,

                      enquiryData.other_cost_included && `Other Cost (${formatDollar(enquiryData.other_cost)})`
                    ]
                      .filter(Boolean)
                      .join(" | ")}
                    {/* {[
                      enquiryData?.full_package && "Ticket",
                      enquiryData?.accommodation_only && "Accommodation",
                      enquiryData?.insurance && "Insurance",
                      enquiryData?.single_room_cost_only && "Single Room",
                      enquiryData?.other_cost_included && "Other Cost"
                    ]
                      .filter(Boolean)
                      .join(" | ")} */}
                  </p>
                </div>
              </div>
            </div>
            {/* <div style={{ display: "flex", marginTop: "10px" }}>
            <p className="provider_containertitle">Card Details</p>
            <hr style={{ flex: "1", marginLeft: "20px" }} />
          </div>
          <div className="form-group creatadmin">
            <div className="rowPrint">
              <div className="columnPrint">
                <label>Payment Method:</label>
                <br />
                <p>{enquiryData ? enquiryData?.payment_method : null}</p>
              </div>

              {enquiryData?.payment_method == "Card" ? (
                <>
                  {" "}
                  <div
                    // className="columnPrint"
                    style={{ float: "left", width: "20%", height: "auto" }}
                  >
                    <label>Card Holder Name:</label>
                    <br />
                    <p>{enquiryData ? enquiryData?.card_holder_name : null}</p>
                  </div>
                  <div
                    //  className="columnPrint"
                    style={{ float: "left", width: "15%", height: "auto" }}
                  >
                    <label>Card No.:</label>
                    <br />
                    <p>{enquiryData ? enquiryData?.card_number : null}</p>
                  </div>
                
                  <div
                    // className="columnPrint"
                    style={{ float: "left", width: "15%", height: "auto" }}
                  >
                    <label>Expiry Date:</label>
                    <br />
                    <p>
                      {enquiryData?.card_expiry_month &&
                      enquiryData?.card_expiry_year
                        ? `${enquiryData.card_expiry_month}/${enquiryData.card_expiry_year}`
                        : ""}
                    </p>
                  </div>
                  <div
                    // className="columnPrint"
                    style={{ float: "left", width: "15%", height: "auto" }}
                  >
                    <label>CVV:</label>
                    <br />
                    <p>{enquiryData ? enquiryData?.card_cvv : null}</p>
                  </div>
                </>
              ) : null}
            </div>
          
          </div> */}
            {/* <div style={{ display: "flex", marginTop: "10px" }}>
          <p className="provider_containertitle">Enquiry Status</p>
          <hr style={{ flex: "1", marginLeft: "20px" }} />
        </div>
        <div className="form-group creatadmin">
          <div className="rowPrint">
            <div className="columnPrint">
              <label>Enquiy Status:</label>
              <br />
              <p>{enquiryData ? enquiryData?.enquiry_status : null}</p>
            </div>
          </div> */}


            {
              enquiryData?.other_cost_included && otherCostDescription && <div >
                <div style={{ display: "flex", marginTop: "10px" }}>
                  <p className="provider_containertitle">Other Cost Description</p>
                  <hr style={{ flex: "1", marginLeft: "20px" }} />
                </div>

                <p style={{ whiteSpace: 'pre-line' }}>
                  {otherCostDescription}
                </p>

              </div>
            }

            <div>


              <div style={{ display: "flex", }} >
                <p className="provider_containertitle">Miscellaneous Details</p>
                <hr style={{ flex: "1", marginLeft: "20px" }} />
              </div>

              {
                miscellaneousData?.length === 0 && <p>No Data</p>
              }

              {
                miscellaneousData && miscellaneousData?.length > 0 && <Table striped bordered hover responsive>
                  <thead>
                    <tr>
                      <th style={{ width: "5%" }}>#</th>
                      <th style={{ width: "25%" }}>Cost Description</th>
                      <th style={{ width: "15%" }}>Cost Amount</th>

                      <th style={{ width: "15%" }}>Date</th>


                    </tr>
                  </thead>
                  <tbody>
                    {miscellaneousData.map((transaction, index) => (
                      <tr key={transaction.id}>
                        <td>{index + 1}</td>
                        <td>{transaction.cost_description}</td>

                        <td>
                          {formatDollar(transaction?.cost_amount)}
                        </td>

                        <td>

                          {moment(transaction?.created_date).format("MM/DD/YYYY")}

                        </td>





                      </tr>
                    ))}
                  </tbody>
                </Table>}

            </div>

            {/* <div>


              <div style={{ display: "flex", }} >
                <p className="provider_containertitle">Credit Details</p>
                <hr style={{ flex: "1", marginLeft: "20px" }} />
              </div>

              {
                enquiryData?.credits?.length === 0 && <p>No Data</p>
              }

              {
                enquiryData?.credits && enquiryData?.credits?.length > 0 && <Table striped bordered hover responsive>
                  <thead>
                    <tr>
                      <th style={{ width: "5%" }}>#</th>
                      <th style={{ width: "25%" }}>Credit Description</th>
                      <th style={{ width: "15%" }}>Credit Amount</th>

                      <th style={{ width: "15%" }}>Date</th>


                    </tr>
                  </thead>
                  <tbody>
                    {enquiryData?.credits.map((transaction, index) => (
                      <tr key={transaction.id}>
                        <td>{index + 1}</td>
                        <td>{transaction.credit_description}</td>

                        <td>
                          {formatDollar(transaction?.credit_amount)}
                        </td>

                        <td> {new Date(
                          transaction?.created_date
                        ).toLocaleDateString()}</td>





                      </tr>
                    ))}
                  </tbody>
                </Table>}

            </div> */}




            <div style={{ display: "flex", marginTop: "10px" }}>
              <p className="provider_containertitle">Payment Details</p>
              <hr style={{ flex: "1", marginLeft: "20px" }} />
            </div>
            <div className="form-group creatadmin">
              <div className="rowPrint">
                {/* <div className="columnPrint">
              <label>Payment Status:</label>
              <br />
              <p>
                {enquiryData?.payment_status ? "Completed" : "Not Completed"}
              </p>
            </div> */}
                {/* <div className="columnPrint">
                  <label>Payment Method:</label>
                  <br />
                  <p>
                    {enquiryData?.payment_method}
                  </p>
                </div>
                <div className="columnPrint">
                  <label>Total Cost:</label>
                  <br />
                  <p>
                    {enquiryData.total_price
                      ? `$ ${enquiryData.total_price}`
                      : `$${0}`}
                  </p>
                </div>
                <div className="columnPrint">
                  <label>Open Balance:</label>
                  <br />
                  <p>
                    {enquiryData.pending_amount
                      ? `$ ${enquiryData.pending_amount}`
                      : `$${0}`}
                  </p>
                </div> */}
              </div>
              {
                enquiryData?.Transactions?.length === 0 && <p>No transaction details found.</p>
              }
              {
                cardPayments && cardPayments?.length > 0 && <Table striped bordered hover responsive>
                  <thead>
                    <tr>
                      <th >#</th>
                      <th >Payment Method</th>
                      <th >Card Number</th>
                      <th >Transaction ID</th>
                      <th>Zip Code</th>
                      <th>Payment From</th>
                      <th>Charge Amount</th>
                      <th>Payment Applied Amount</th>
                      <th>Date</th>
                      {/* <th>Payment Status</th> */}
                    </tr>
                  </thead>
                  <tbody>
                    {cardPayments.map((transaction, index) => (
                      <tr key={transaction.id}>
                        <td>{index + 1}</td>
                        <td>{transaction.payment_method}</td>

                        <td>
                          {transaction.card_number !== "Non" ? (
                            <p style={{ margin: 0 }}>******{transaction.card_number}</p>
                          ) : (
                            "-"
                          )}
                        </td>

                        <td>{transaction.transaction_id}</td>


                        <td>{transaction?.billing_zip ? transaction?.billing_zip : "-"}</td>
                        <td style={{ display: "flex", gap: "10px" }}>{transaction.payment_from} </td>
                        <td>{transaction?.card_fee ? formatDollar(Number(transaction.amount) + Number(transaction.card_fee)) : formatDollar(transaction.amount)}</td>

                        <td>{formatDollar(transaction.amount)}</td>
                        <td>
                          {moment(transaction.created_date).format("MM/DD/YYYY")}

                        </td>
                        {/* <td>
                                       {transaction.recieved ? "Received" : "Not Received"}
                                     </td> */}
                      </tr>
                    ))}
                  </tbody>
                </Table>
              }

              {
                otherPayments && otherPayments?.length > 0 && <Table striped bordered hover responsive>
                  <thead>
                    <tr>
                      <th >#</th>
                      <th >Payment Method</th>
                      <th >Note</th>


                      <th>Zip Code</th>
                      <th>Payment From</th>
                      <th>Charge Amount</th>
                      <th>Payment Applied Amount</th>
                      <th>Date</th>
                      {/* <th>Payment Status</th> */}
                    </tr>
                  </thead>
                  <tbody>
                    {otherPayments.map((transaction, index) => (
                      <tr key={transaction.id}>
                        <td>{cardPayments?.length + index + 1}</td>
                        <td>{transaction.payment_method}

                          {
                            transaction.payment_method === 'Check' && <>
                              <br />

                              <span style={{ fontSize: '12px', whiteSpace: 'nowrap' }}>( Check No:  {transaction?.transaction_id} )</span>
                            </>
                          }

                          {
                            (transaction.payment_method === 'Zelle') && <>
                              <br />

                              <span style={{ fontSize: '12px', whiteSpace: 'nowrap' }}>( Txn No:  {transaction?.transaction_id} )</span>
                            </>
                          }
                        </td>



                        <td>{transaction?.note ?? "-"}</td>


                        <td>{transaction?.billing_zip ? transaction?.billing_zip : "-"}</td>
                        <td style={{ display: "flex", gap: "10px" }}>{transaction.payment_from} </td>
                        <td>{transaction?.card_fee ? formatDollar(Number(transaction.amount) + Number(transaction.card_fee)) : formatDollar(transaction.amount)}</td>

                        <td>{formatDollar(transaction.amount)}</td>
                        <td>
                          {moment(transaction.created_date).format("MM/DD/YYYY")}

                        </td>
                        {/* <td>
                                       {transaction.recieved ? "Received" : "Not Received"}
                                     </td> */}
                      </tr>
                    ))}
                  </tbody>
                </Table>
              }


              <Row >

                <Col md={2}>
                  <label>Total Cost:</label>
                  <p>
                    {formatDollar(enquiryData?.total_price)}
                  </p>
                </Col>

                <Col md={2}>
                  <label>Total Paid:</label>
                  <p>
                    {formatDollar(enquiryData.total_price - enquiryData.pending_amount - getTotalCredit(enquiryData.credits))}
                  </p>
                </Col>

                {/* <Col md={2}>
                  <label>Credit:</label>
                  <p>
                    {formatDollar(getTotalCredit(enquiryData.credits))}
                  </p>
                </Col> */}

                <Col md={2}>
                  <label>Open Balance:</label>
                  <p>
                    {formatDollar(enquiryData.pending_amount)}
                  </p>
                </Col>
              </Row>

            </div>

            <div style={{ display: "flex", marginTop: "10px" }}>
              <p className="provider_containertitle">Billing Address</p>
              <hr style={{ flex: "1", marginLeft: "20px" }} />
            </div>
            <div className="form-group creatadmin2">
              <div className="rowPrint">
                <div className="columnPrint">
                  <label>Address:</label>
                  <br />
                  <p>{enquiryData ? enquiryData?.billing_address : null}</p>
                </div>
                <div className="columnPrint">
                  <label>City:</label>
                  <br />
                  <p>{enquiryData ? enquiryData?.billing_city : null}</p>
                </div>
                <div className="columnPrint">
                  <label>State:</label>
                  <br />
                  <p>{enquiryData ? enquiryData?.billing_state : null}</p>
                </div>
                <div className="columnPrint">
                  <label>Zip Code:</label>
                  <br />
                  <p>{enquiryData ? enquiryData?.billing_zip : null}</p>
                </div>
              </div>
            </div>
            <div className="form-group creatadmin">
              <div className="rowPrint">
                <div className="columnPrint">
                  <label>Country:</label>
                  <br />
                  <p>{enquiryData ? enquiryData?.billing_country : null}</p>
                </div>
              </div>
            </div>

            <div style={{ display: "flex", marginTop: "10px" }}>
              <p className="provider_containertitle">Remarks</p>
              <hr style={{ flex: "1", marginLeft: "20px" }} />
            </div>
            <div className="form-group creatadmin">
              <div className="rowPrint">
                <div className="columnPrint">
                  <p>{enquiryData?.remarks || "No Remarks found"}</p>
                </div>
              </div>
            </div>

          </div>
        </div>
      </div>
    </>
  );
});

export default PrintEnquiryStatus;
